import { fetchFullProductGroupsAction } from '../actions';
import { put, call, select } from 'redux-saga/effects';
import { ProductGroups } from '@app/shared/types/baseMargin';
import { TCommercialOrganization } from '@app/services/filter-service/response-interfaces/get-co.response';
import { selectSelectedCo } from '@app/store/filters-module/co';
import { enqueSnackAction } from '@app/store/snacks';
import { RightsApi } from '@app/services/rights-service/rights-service';
import { setProductGroup } from '@app/store/baseMargin';

export function* fetchFullProductGroupsWorkerSaga(
  action: ReturnType<typeof fetchFullProductGroupsAction>
) {
  try {
    const selectedCo: TCommercialOrganization = yield select(selectSelectedCo);
    
    const result: ProductGroups = yield call(
      RightsApi.fetchFullProductGroups,
      {
        ...action.payload,
        coId: selectedCo.id,
      }
    );
    yield put(setProductGroup({ payload: result }));
  } catch (e) {
    if (e.response && e.response.status === 409) {
      yield put(
        enqueSnackAction({
          notification: {
            message: e.response.data.message,
            options: {
              variant: 'error',
            },
            key: 'create fetch product group error',
          },
        })
      );
    }
    yield put(
      enqueSnackAction({
        notification: {
          message: 'Something wrong...',
          options: {
            variant: 'error',
          },
          key: 'create fetch product group error',
        },
      })
    );
  }
}
